import React, { useEffect, useState } from 'react'
import classes from './smallLabForm.module.scss'
import { Controller, useForm } from 'react-hook-form'
import classNames from 'classnames';
import Select from 'react-select'
import { DoctorService } from '../../../api/DoctorService'
import { useSelector } from 'react-redux'
import { laborantService } from '../../../api/laborantService';
import { toast } from 'react-toastify';

const SmallLabForm = ({onChange}) => {

  const [formValue, setFormValue] = useState()
  const [renderForm, setRenderForm] = useState(false)
  const [laborantCard, setLaborantCard] = useState({
    'description': '',
    'cassets': [],
    'archive': '',
    'calcium': '',
    'doc': '',
    'laborant': ''
  })

  const closeButton = () => {
    onChange(false)
  }

  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: {errors},
    control
  } = useForm()

  let value  = '1'
  let type

  const form = useSelector(state => state.RegScan.ScanInputs)

  if (form.research === 'Гістологія'){
    type = 'Gistology'
  } else if (form.research === 'Експрес'){
    type = 'Express'
  }

  const values = useSelector(state => state.labForm)

  const getOptions = async() =>{
    await DoctorService.getAllWorkersByRole().then(res=>{
      if(res?.data){
        value.fields.map(async(element)=>{
          if(element.legend == 'Лікар'){
            res?.data.doctor.map(docs=>{
              let obj = {
                "value": docs.name,
                "label": docs.name,
                "id":docs.id,
                "type": 'option'
              }
            doc.push(obj)
            })
          } else if (element.legend == 'Лаборант'){
            res?.data.laboratoryAssistant.map(labor=>{
              let obj = {
                  "value": labor.name,
                  "label": labor.name,
                  "id":labor.id,
                  "type": 'option'
              }
              lab.push(obj)
            })
          }
        })
      } 
    })
  }

  let doc = []
  let lab = []

  values.map((el)=>{
    if (el.formType === type){
      if (type === 'Gistology'){
        value = el
      } else if (type === 'Express'){
        value = el
      }
    }
  })

  useEffect(() => {
    const fetchData = async () => {
      if (value !== "1") {
        // Wait for getOptions to populate doc and lab
        await getOptions();
  
        // Call getLabCard after options are populated
        await getLabCard(form.id, doc, lab);
  
        // Set form values and render state
        setFormValue(value);
        setFormValue((state) => ({
          ...state,
          fields: state?.fields?.map((item) => {
            let option;
            if (item.name === "doc") {
              option = doc;
            }
            if (item.name === "laborant") {
              option = lab;
            }
            return option
              ? {
                  ...item,
                  props: option,
                }
              : { ...item };
          }),
        }));
        setRenderForm(true);
      }
    };
  
    fetchData();
  }, [value]);

  const getLabCard = async(id, doc , lab) =>{
    await laborantService.getDirection(id).then(res=>{
      if(res?.data){
        let docId = res?.data.laboratoryForm.doctorId
        let labId = res?.data.laboratoryForm.laboratoryAssistantId
        const docItem = doc.find((el) => el.id === docId)
        const labItem = lab.find((el) => el.id === labId)
        const docName = docItem ? docItem.label : ''
        const labName = labItem ? labItem.label : ''
        if (docName && labName) {
          setValue("description", `${res?.data.laboratoryForm.data.description}`)
          setValue("archive", `${res?.data.laboratoryForm.data.archive}`)
          setValue("calcium", `${res?.data.laboratoryForm.data.calcium}`)
          setValue("doc", {id: docId, label: docName, value: docName})
          setValue("laborant", {id: labId, label: labName, value: lab})
        }
      }
    })
  }

  const onSubmit = (data) =>{
    handleLaborant(data)
  }

  const handleLaborant = (data) => {
    if (type === 'Gistology'){
        let arr = []
        for(let key in data){
            if (key.includes('casset')){
                arr.push(data[key]);
            }
        }
        setLaborantCard({
            'doctorId': data.doc.id,
            'laboratoryAssistantId': data.laborant.id,
            'data': {
                'description': data.description,
                'archive': data.archive,
                'calcium': data.calcium,
            }
        })
    } else {
        setLaborantCard({
            'data': {
                'description': data.description
            },
            'doctorId': data.doc.id,
            'laboratoryAssistantId': data.laborant.id
        })
    }
  }

  useEffect(()=>{
    if(laborantCard.description !== ''){
      updateHandler(form.id, laborantCard)
      onChange(false)
    }
  },[laborantCard])

  const updateHandler = async(id, formOuput) => {
    await laborantService.updateLabForm(id, {data: formOuput.data, doctorId: formOuput.doctorId, laboratoryAssistantId: formOuput.laboratoryAssistantId}).then(res=>{
      if (res) toast.done('Скерування оновлено')
    })
  }

  return (
    <div className={classes.container}>
      <button onClick={closeButton} className={classes.closeButton}>
        X
      </button> 
      {renderForm && 
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          {formValue.fields.map((el, index) => (
            <div className={classes[values.class]} key={index}>
            {el.name !== 'cassetsAfter' && <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>}
            {el.name == 'cassetsAfter' && <legend className={classes.form__label} htmlFor={el.type}>Кількість зареєстрованих касет:{form.quantityMaterial}</legend>}
            <div className={classNames(el.name == 'cassetsAfter' ? classes.form__input__cassets : classes.form__label__container, {[classes.register__container]: values.formType == 'singIn'})}>
            {el.options ? (
              <Controller
                control={control}
                name={el.name}
                render={({field: {onChange, value}}) => (
                  <Select
                    className={classes.select}
                    options={el.props}
                    value={value ? value : []}
                    onChange={onChange}
                    disableSearch
                    hasSelectAll={false}
                    placeholder={el.name === 'doc' ? 'Оберіть лікаря...' : 'Оберіть лаборанта...'}
                  />
                 )}
              />
            ) : (
              el.name !== 'cassetsAfter' && el.props.map((props, i) =>(
                <div className={classNames(classes.form__label__container__box, {[classes.register__container]: values.formType == 'singIn'})} key={'a' + i}>
                <div>{el.name !== 'cassetsAfter' && <label>{props.label}</label>}</div>
                <div className={el.name == 'cassetsAfter' ? classes.form__input__cassets : {}}>
                {el.name !== 'sign' && el.name !== 'cassetsAfter' && el.type !== 'textarea' && 
                  <input 
                    className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                    type={props.type}
                    min={props.min}
                    max={props.max}
                    disabled={props.show}
                    placeholder={props.placeholder}
                    pattern={props.pattern}
                    value={el.type == 'radio' ? props.label : props.value}
                    {...register(el.name == 'age' || el.name == 'cassetsAfter' ? props.register : el.name)}
                  />
                }
                {el.type === 'textarea' && el.name !== 'cassetsAfter' &&
                  <textarea
                    className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                    type={props.type}
                    min={props.min}
                    max={props.max}
                    disabled={props.show}
                    placeholder={props.placeholder}
                    pattern={props.pattern}
                    value={el.type == 'radio' ? props.label : props.value}
                    {...register(el.name == 'age' || el.name == 'cassetsAfter' ? props.register : el.name, {required: el.required})}
                  />}
                  {errors[el.name] && (
                    <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                      Це поле є обов'язковим
                    </p>
                )}
                </div>
            </div>
            ))
            )}
          </div>
          </div>
          ))}
          <button className={classes.form__button} type="submit">Змінити значення</button>
        </form>
      }
    </div>
  )
}

export default SmallLabForm